// Updated to use the new public Google Sheets URL
const PUBLIC_SHEET_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSl-DP-fl6G6nAXSjPcqCiGUJPNdB6mnD971fw4POs8_sEBpAa8NQkQQzVV_HL3xiuWfSHlFMb7zb61/pubhtml?gid=0&single=true';

// Function to convert image URLs from HTML to JPG format
const convertImageUrl = (url) => {
  if (url && url.includes('content.raheem.work') && url.includes('.html?player=DASZeph')) {
    return url.replace('.html?player=DASZeph', '.jpg');
  }
  return url;
};

// Function to parse CSV text properly
const parseCSV = (text) => {
  const lines = text.split('\n');
  const result = [];
  for (let line of lines) {
    if (!line.trim()) continue;
    const row = [];
    let current = '';
    let inQuotes = false;
    for (let i = 0; i < line.length; i++) {
      const char = line[i];
      const nextChar = line[i + 1];
      if (char === '"') {
        if (inQuotes && nextChar === '"') {
          // Escaped quote
          current += '"';
          i++; // Skip next quote
        } else {
          // Toggle quote state
          inQuotes = !inQuotes;
        }
      } else if (char === ',' && !inQuotes) {
        // End of field
        row.push(current.trim());
        current = '';
      } else {
        current += char;
      }
    }
    // Add last field
    row.push(current.trim());
    result.push(row);
  }
  return result;
};

export const fetchProjectsData = async () => {
  try {
    console.log('Fetching projects data from:', PUBLIC_SHEET_URL);
    const response = await fetch(PUBLIC_SHEET_URL, {
      method: 'GET',
      headers: {
        'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const htmlText = await response.text();
    console.log('HTML Response received:', htmlText.substring(0, 200) + '...');

    // Extract CSV data from the HTML response
    // Look for table data in the HTML
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, 'text/html');
    const table = doc.querySelector('table');

    if (!table) {
      throw new Error('No table found in HTML response');
    }

    const rows = Array.from(table.querySelectorAll('tr'));
    const csvRows = rows.map(row => {
      const cells = Array.from(row.querySelectorAll('td,th'));
      return cells.map(cell => cell.textContent.trim());
    });

    if (csvRows.length === 0) {
      throw new Error('No data found in table');
    }

    // First row contains headers
    const headers = csvRows[0];
    console.log('Headers found:', headers);

    const projects = [];

    // Process data rows (skip header row)
    for (let i = 1; i < csvRows.length; i++) {
      const row = csvRows[i];
      if (row.length === 0 || (row.length === 1 && row[0] === '')) continue;

      const project = { id: i };

      // Map headers to values, only including columns A-Z (first 26 columns)
      for (let j = 0; j < Math.min(headers.length, 26, row.length); j++) {
        const value = row[j] ? row[j].trim() : '';
        if (value && value !== '') {
          // Convert image URLs but keep video URLs as-is
          if (headers[j].toLowerCase().includes('image')) {
            project[headers[j]] = convertImageUrl(value);
          } else {
            project[headers[j]] = value;
          }
        }
      }

      // Only include projects that have Project Image 1
      if (project['Project Image 1']) {
        console.log('Valid project found:', project['Project Name']);
        projects.push(project);
      }
    }

    console.log('Total projects loaded:', projects.length);
    return projects;
  } catch (error) {
    console.error('Error fetching projects data:', error);
    // Fallback to real Raheem Bishop project data with converted image URLs
    console.log('Using fallback data with real projects due to fetch error');
    return [
      {
        id: 1,
        'Project Name': 'Windermere Retail',
        'Project Overview': '12,500 sq ft new retail center and hardware store delivered as gray and vanilla shells. Leading PM, architectural design and CA, I coordinated AHJ/DRC and town‑hall interactions and managed consultant teams—gaining deeper insight into municipal processes, design standards, and how regulatory engagement affects schedule and scope.',
        'Location': '523 Main St, Windermere, FL 34786',
        'Type': 'Retail Center & Hardware Store',
        'Scope': 'New - Ground Up Gray & Vanilla Building Shells',
        'Role(s) ': 'Project Management, Architectural Design, CA & Coordination',
        'Size/ Area': '12,500 Sq Ft.',
        'Status': 'Completed',
        'Timeline': 'Completed: June 2025',
        'Client': 'V 3 Capital',
        'Firm/ Studio': 'Cormia Design Group',
        'Team & Collaborators/ Disciplines': 'Coworkers at Cormia Design Group + S/MEP/FP & Civil Disciplines',
        'Project Outcomes & Recognition': 'Achievement(s): AHJ/ DRC/ Town Hall Coordination and Design Standards. Successful management of a fairly complex project from a design, construction and consultant coordination standpoint. Key Challenge(s): Changes during construction and managing timeline. Lesson(s) Learnt/ Career Growth: Improved managerial skills and CA procedureal knowledge. Experienced the process and gained a deeper understanding of AHJ/ DRC City requirements and how those can impact a project\'s design and timeline. Further gained deeper knowledge into consultant coordination and managing client expectations.',
        'Project Image 1': 'https://content.raheem.work/file/RB/Architectural-Projects/Windermere-Retail-Prof-1.jpg',
        'Project Image 2': 'https://content.raheem.work/file/RB/Architectural-Projects/Windermere-Retail-Prof-2.jpg',
        'Project Image 3': 'https://content.raheem.work/file/RB/Architectural-Projects/Windermere-Retail-Prof-3.jpg',
        'Project Image 4': 'https://content.raheem.work/file/RB/Architectural-Projects/Windermere-Retail-Prof-4.jpg',
        'Project Image 5': 'https://content.raheem.work/file/RB/Architectural-Projects/Windermere-Retail-Prof-5.jpg',
        'Project Image 6': 'https://content.raheem.work/file/RB/Architectural-Projects/Windermere-Retail-Prof-6.jpg',
        'Project Image 7': 'https://content.raheem.work/file/RB/Architectural-Projects/Windermere-Retail-Prof-7.jpg',
        'Project Image 8': 'https://content.raheem.work/file/RB/Architectural-Projects/Windermere-Retail-Prof-8.jpg',
        'Project Image 9': 'https://content.raheem.work/file/RB/Architectural-Projects/Windermere-Retail-Prof-9.jpg',
        'Project Image 10': 'https://content.raheem.work/file/RB/Architectural-Projects/Windermere-Retail-Prof-10.jpg',
        'Project Image 11': 'https://content.raheem.work/file/RB/Architectural-Projects/Windermere-Retail-Prof-11.jpg',
        'Project Image 12': 'https://content.raheem.work/file/RB/Architectural-Projects/Windermere-Retail-Prof-12.jpg',
        'Project Video 1': 'https://content.raheem.work/file/RB/Architectural-Projects/Windermere-Retail-Video-1.html?player=DASZeph'
      },
      {
        id: 2,
        'Project Name': '7-Eleven At Horizon West – Store 41329',
        'Project Overview': '3,500 sq ft convenience store delivered as a ground‑up shell (canopy and pumps by others). Serving as PM and architect with CA responsibilities, I focused on design and detailed building geometry, on‑site coordination with the GC, and client expectation management—gaining foundational gas‑station knowledge and improved detailing workflows.',
        'Location': '9255 Miley Drive, Winter Garden, FL 34787',
        'Type': 'Gas Station & Convenience Store',
        'Scope': 'New - Ground Up Building Shell (Conveniene Store). Gas pumps and canopy done by others',
        'Role(s)': 'Project Management, Architectural Design, CA & Coordination',
        'Size/ Area': '3,500 Sq ft. (Convenience Store Only)',
        'Status': 'Completed',
        'Timeline': 'Completed: March 2024',
        'Client': 'Confidential',
        'Firm/ Studio': 'Cormia Design Group',
        'Team & Collaborators/ Disciplines': 'Coworkers at Cormia Design Group + S/MEP/FP & Civil Disciplines',
        'Project Outcomes & Recognition': 'Achievement(s): Assistance with designing first gas station. Construction knowledge. Key Challenge(s): Design & Detailing Lesson(s) Learnt/ Career Growth: Development of design skills and detailing of various forms and shapes on the building along with improvement of on-site coordination with general contractors. Also learnt more about managing client expectations.',
        'Project Image 1': 'https://content.raheem.work/file/RB/Architectural-Projects/7-11-Winter-Garden-1.jpg',
        'Project Image 2': 'https://content.raheem.work/file/RB/Architectural-Projects/7-11-Winter-Garden-3.jpg',
        'Project Image 3': 'https://content.raheem.work/file/RB/Architectural-Projects/7-11-Winter-Garden-8.jpg',
        'Project Image 4': 'https://content.raheem.work/file/RB/Architectural-Projects/7-11-Winter-Garden-9.jpg',
        'Project Image 5': 'https://content.raheem.work/file/RB/Architectural-Projects/7-11-Winter-Garden-Design-1.jpg'
      },
      {
        id: 3,
        'Project Name': 'Exotic & Classic Car Club Orlando',
        'Project Overview': '50,000 sq ft renovation including exterior façade improvements and a full interior revamp; serving as co‑project manager, co‑architect and co‑interior designer with CA and coordination responsibilities. The ongoing work demands intensive consultant coordination and site‑driven problem solving, enhancing my skills in integrated lighting/finish strategies and managing complex renovation unknowns.',
        'Location': '135 N Oregon St, Sanford, FL 32771',
        'Type': '5-Story Self-Storage Building with Retail Shell Spaces on Ground Floor',
        'Scope': 'Renovation - Exterior Facades & Full Interior Revamp',
        'Role(s)': 'Co-Project Management, Co-Architectural Design, Co-Interior Design, CA & Coordination',
        'Size/ Area': '50,000 Sq ft.',
        'Status': 'Ongoing Construction',
        'Timeline': 'N/A',
        'Client': 'Great American Land Management & Audi North Orlando',
        'Firm/ Studio': 'Cormia Design Group',
        'Team & Collaborators/ Disciplines': 'Coworkers at Cormia Design Group + S/MEP/FP & Civil Disciplines',
        'Project Outcomes & Recognition': 'Achievement(s): Project management of mid-scale size project and navigating complex unknowns on the fly. Key Challenge(s): Changes to design and construction procedures due to unforeseen existing conditions on the building once the facades were removed. Lesson(s) Learnt/ Career Growth: Further development of structural knowledge and buidling construction. Improved managerial skills and CA procedureal knowledge. Gained deeper knowledge into consultant coordination and managing client expectations. Learnt about the importance of lighting and design coordination with all trades involved.',
        'Project Image 1': 'https://content.raheem.work/file/RB/Architectural-Projects/ECCCO-1.jpg',
        'Project Image 2': 'https://content.raheem.work/file/RB/Architectural-Projects/ECCCO-2.jpg',
        'Project Image 3': 'https://content.raheem.work/file/RB/Architectural-Projects/ECCCO-3.jpg',
        'Project Image 4': 'https://content.raheem.work/file/RB/Architectural-Projects/ECCCO-4.jpg',
        'Project Image 5': 'https://content.raheem.work/file/RB/Architectural-Projects/ECCCO-5.jpg'
      },
      {
        id: 4,
        'Project Name': 'Hangry Bison Lake Mary',
        'Project Overview': '7,000 sq ft restaurant exterior and interior façade renovation with an outdoor dining patio. Managing PM, architectural and co‑interior responsibilities plus CA, I addressed complex MEP, space‑planning and permitting requirements—refining my detailing approach and understanding of restaurant‑specific build‑out needs.',
        'Location': 'Colonial Town Park, 951 Market Promenade Ave #1115, Lake Mary, FL 32746',
        'Type': 'Restaurant',
        'Scope': 'Exterior & Interior Facade Renovation',
        'Role(s)': 'Project Management, Architectural Design, Co-Interior Design, CA & Coordination',
        'Size/ Area': '7,000 Sq Ft.',
        'Status': 'Completed',
        'Timeline': 'Completed: June 2025',
        'Client': 'Hangry Bison',
        'Firm/ Studio': 'Cormia Design Group',
        'Team & Collaborators/ Disciplines': 'Coworkers at Cormia Design Group + S/MEP/FP & Civil Disciplines',
        'Project Outcomes & Recognition': 'Achievement(s): Project management of a small but complex project with an outdoor dining patio. Key Challenge(s): Timeline Management. AHJ/ DRC/ Permitting requirements Lesson(s) Learnt/ Career Growth: Improved my ability to work through AHJ/ DRC requirements on projects. Learnt more about CA procedures. Improved my understanding of architectural detailing and the intricate needs of restaurants in terms of MEP and various space planning needs.',
        'Project Image 1': 'https://content.raheem.work/file/RB/Architectural-Projects/Hangry-Bison-1.jpg',
        'Project Image 2': 'https://content.raheem.work/file/RB/Architectural-Projects/Hangry-Bison-2.jpg',
        'Project Image 3': 'https://content.raheem.work/file/RB/Architectural-Projects/Hangry-Bison-3.jpg',
        'Project Image 4': 'https://content.raheem.work/file/RB/Architectural-Projects/Hangry-Bison-Night-1.jpg'
      },
      {
        id: 5,
        'Project Name': 'Vision Car Wash Apopka',
        'Project Overview': 'Ground‑up car wash facility with interior build‑out. As PM and designer through CA, I learned the specialized operational and MEP requirements for car‑wash facilities and emphasized tight coordination with consultants and contractors to address design changes and timeline constraints.',
        'Location': '355 W Orange Blossom Trail, Apopka, FL 32712',
        'Type': 'Car Wash Facility',
        'Scope': 'Ground Up New Building & Interior',
        'Role(s)': 'Project Management, Architectural Design, CA & Coordination',
        'Size/ Area': '4,000 Sq Ft.',
        'Status': 'Completed',
        'Timeline': 'Completed: January 2023',
        'Client': 'Vision Car Wash',
        'Firm/ Studio': 'Cormia Design Group',
        'Team & Collaborators/ Disciplines': 'Coworkers at Cormia Design Group + S/MEP/FP & Civil Disciplines',
        'Project Outcomes & Recognition': 'Achievement(s): First experience with car wash project and understanding the requirements for such facilities. Key Challenge(s): Timeline Management. Consultant and general contractor coordination. Design changes at various times throughout the project. Lesson(s) Learnt/ Career Growth: Learnt more about the requirements for car washes and all the bits and pieces that go into it.',
        'Project Image 1': 'https://content.raheem.work/file/RB/Architectural-Projects/Vision-Car-Wash-Apopka-1.jpg',
        'Project Image 2': 'https://content.raheem.work/file/RB/Architectural-Projects/Vision-Car-Wash-Apopka-2.jpg',
        'Project Image 3': 'https://content.raheem.work/file/RB/Architectural-Projects/Vision-Car-Wash-Apopka-3.jpg',
        'Project Image 4': 'https://content.raheem.work/file/RB/Architectural-Projects/Vision-Car-Wash-Apopka-4.jpg'
      },
      {
        id: 6,
        'Project Name': 'Formosa Gardens',
        'Project Overview': 'Exterior façade renovation for a retail shopping plaza (1,100 linear ft). As PM and designer handling CA and coordination, I navigated unforeseen existing conditions that required rapid design and construction adjustments, growing my structural knowledge and procedural competence in construction administration.',
        'Location': '7864 W Irlo Bronson Memorial Hwy, Kissimmee, FL 34747',
        'Type': 'Retal Shopping Plaza',
        'Scope': 'Renovation - Exterior Facades',
        'Role(s)': 'Project Management, Architectural Design, CA & Coordination',
        'Size/ Area': '1,100 Linear ft.',
        'Status': 'Completed',
        'Timeline': 'Completed: August 2023',
        'Client': 'Formosa Gardens Village',
        'Firm/ Studio': 'Cormia Design Group',
        'Team & Collaborators/ Disciplines': 'Coworkers at Cormia Design Group + S/MEP Disciplines',
        'Project Outcomes & Recognition': 'Achievement(s): Project management of mid-scale size project and navigating complex unknowns on the fly. Key Challenge(s): Changes to design and construction procedures due to unforeseen existing conditions on the building once the facades were removed. Lesson(s) Learnt/ Career Growth: Development of structural knowledge and buidling construction. Improved managerial skills and CA procedureal knowledge.',
        'Project Image 1': 'https://content.raheem.work/file/RB/Architectural-Projects/Formosa-Gardens-Render-1.jpg',
        'Project Image 2': 'https://content.raheem.work/file/RB/Architectural-Projects/Formosa-Gardens-Render-2.jpg'
      },
      {
        id: 7,
        'Project Name': 'BOOS Heartland Dental - Daytona',
        'Project Overview': '5,000 sq ft ground‑up dental office shell where I led PM, architectural design and CA. The project reinforced my familiarity with AHJ/DRC permitting workflows and contractor coordination for retail/shell healthcare projects, improving my ability to navigate regulatory and timeline challenges.',
        'Location': 'Tymber Creek Rd, Daytona Beach, FL 32124',
        'Type': 'Dental Office',
        'Scope': 'Ground Up New Building Shell',
        'Role(s)': 'Project Management, Architectural Design, CA & Coordination',
        'Size/ Area': '5,000 Sq Ft.',
        'Status': 'Completed',
        'Timeline': 'Completed: August 2024',
        'Client': 'WMG Development',
        'Firm/ Studio': 'Cormia Design Group',
        'Team & Collaborators/ Disciplines': 'Coworkers at Cormia Design Group + S/MEP & Civil Disciplines',
        'Project Outcomes & Recognition': 'Achievement(s): AHJ/ DRC processes and Permitting procedures. Gained better understanding of retail shell buildings in my continuing quest to learn everyday. Key Challenge(s): Timeline Management. Unforeseen changes during Construction, Lesson(s) Learnt/ Career Growth: Learnt more about general contractor coordination and CA procedures. Improved my ability to work through AHJ/ DRC requirements on projects.',
        'Project Image 1': 'https://content.raheem.work/file/RB/Architectural-Projects/Heartland-Dental-1.jpg',
        'Project Image 2': 'https://content.raheem.work/file/RB/Architectural-Projects/Heartland-Dental-2.jpg'
      },
      {
        id: 8,
        'Project Name': 'Pompano Self-Storage',
        'Project Overview': 'Five‑story, 120,000 sq ft ground‑up self‑storage building with retail shell spaces on the ground floor. I led project management and construction administration, coordinating S/MEP/FP and civil disciplines to manage multi‑story construction challenges, unforeseen changes, and schedule pressures—strengthening my managerial skills and technical understanding of self‑storage design and delivery.',
        'Location': '950 E McNab Rd, Pompano Beach, FL 33060',
        'Type': '5-Story Self-Storage Building with Retail Shell Spaces on Ground Floor',
        'Scope': 'New - Ground Up Building Shell',
        'Role(s)': 'Project Management, CA',
        'Size/ Area': '120,000 Sq ft.',
        'Status': 'Completed',
        'Timeline': 'Completed: December 2024',
        'Client': 'Confidential',
        'Firm/ Studio': 'Cormia Design Group',
        'Team & Collaborators/ Disciplines': 'Coworkers at Cormia Design Group + S/MEP/FP & Civil Disciplines',
        'Project Outcomes & Recognition': 'Achievement(s): Project management of mid-scale size project with multiple stories. Key Challenge(s): Timeline Management. Unforesoen changes during Construction, Lesson(s) Learnt/ Career Growth: Development of managerial skills with all players/ disciplines involved and further understanding the requirements for a self-storage building.',
        'Project Image 1': 'https://content.raheem.work/file/RB/Architectural-Projects/Pompano-Storage-View-1.jpg',
        'Project Image 2': 'https://content.raheem.work/file/RB/Architectural-Projects/Pompano-Storage-View-2.jpg'
      }
    ];
  }
};